module.exports = "../images/bass-fishing-ontario@2x.jpg?v=6eb99b4";